var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivePrediction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1818 6.13636L14.5227 13.7818C14.5227 14.6584 13.8175 15.3636 12.9409 15.3636H5.55909C4.6825 15.3636 3.97727 14.6584 3.97727 13.7818L3.31818 6.13636M11.8864 6.13636V7.58636C11.8864 7.7262 11.8308 7.86032 11.7319 7.9592C11.633 8.05808 11.4989 8.11364 11.3591 8.11364H7.14091C7.00107 8.11364 6.86695 8.05808 6.76807 7.9592C6.66919 7.86032 6.61364 7.7262 6.61364 7.58636V6.13636M3.05455 3.5H15.4455C15.7251 3.5 15.9934 3.6111 16.1911 3.80887C16.3889 4.00663 16.5 4.27486 16.5 4.55455V5.08182C16.5 5.2203 16.4727 5.35743 16.4197 5.48538C16.3667 5.61332 16.2891 5.72957 16.1911 5.82749C16.0932 5.92542 15.977 6.0031 15.849 6.05609C15.7211 6.10909 15.5839 6.13636 15.4455 6.13636H3.05455C2.77486 6.13636 2.50663 6.02526 2.30887 5.82749C2.1111 5.62973 2 5.3615 2 5.08182V4.55455C2 4.41606 2.02728 4.27893 2.08027 4.15099C2.13327 4.02304 2.21095 3.90679 2.30887 3.80887C2.50663 3.6111 2.77486 3.5 3.05455 3.5Z",
    stroke: "#6A7282",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivePrediction);
export default __webpack_public_path__ + "static/media/ArchivePrediction.298ac126fc40c931ae0497a310289e30.svg";
export { ForwardRef as ReactComponent };